import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS, FEATURE_FLAGS, HOTEL } from "../../../../constants/Define";
import CONFIG from '../../../../constants/Config';
import { generatePath, Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import RateList from './RateList';
import Ripple from '../../common/component/Ripple';
import { Button, Alert, message, Modal, List, Checkbox, Radio } from 'antd';
import update from 'immutability-helper';
import { isEqual } from 'lodash';
import { getContentLanguage } from '../../../../utils/commonUtils';
import Wrapper from '../../common/component/Wrapper';
import RenderHotelisActive from '../Hotels/HotelList/RenderHotelisActive';
import SyncModal from './SyncModal/SyncModal';
import ImportModal from './ImportModal/ImportModal';
import { importRateDescription } from '../../../../services/rateService';
import './Rates.less';

const parseFilenameFromContentDisposition = (disposition) => {
    if (!disposition) return null;
    const utf8Match = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        try {
            return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
        } catch (e) {
            // fall through
        }
    }
    const match = disposition.match(/filename="?([^";]+)"?/i);
    return match ? match[1].trim() : null;
};

const { confirm } = Modal

let permisionActions = [];

class PopUpConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            replaceLanguage: 'vi-VN',
        }
    }
    onReplaceLanguageChange = e => {
        this.setState({ replaceLanguage: e.target.value });
        this.props.onSelected(e.target.value);
    }
    render() {
        const { t } = this.props;
        const noReplace = t('item.rate.syncRateLanguage.noReplace');
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Radio.Group onChange={this.onReplaceLanguageChange} value={this.state.replaceLanguage}>
                <Radio style={radioStyle} value={'vi-VN'}>{t(`translate.languages.vi`)}</Radio>
                <Radio style={radioStyle} value={'ko-KR'}>{t(`translate.languages.ko`)}</Radio>
                <Radio style={radioStyle} value={''}>{noReplace}</Radio>
            </Radio.Group>
        )
    }
}
export default class RoomTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preHotelId: this.props.match.params.hotel_id,
            filters: {
                hotelId: this.props.match.params.hotel_id,
                isActive: true,
                pageSize: this.props.rateState.pageSize,
                pageIndex: this.props.rateState.pageIndex,
            },
            isSort: false,
            isVisible: false,
            isVisibleSyncModal: false,
            isVisibleImportModal: false,
            rates: [],
            ratesActive: [],
            // isShowError: false
        };
        this.ChildElement = React.createRef();
        this.isCheckSync = true;
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        this.props.getListRates(this.state.filters);
        if (this.state.filters?.hotelId) {
            this.props.getHotelDetail(this.state.filters.hotelId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.rateState.isFetchSync) {
            this.isCheckSync = true;
        }
        if (nextProps.rateState.dataList && !isEqual(nextProps.rateState.dataList, this.props.rateState.dataList)) {
            this.setState({ rates: nextProps.rateState.dataList });
        }
        if (!isEqual(nextProps.rateState.dataSync, this.props.rateState.dataSync)) {
            if (nextProps.rateState.dataSync && nextProps.rateState.dataSync.length > 0) {
                this.setState({ isVisible: true });
            } else {
                this.setState({ isVisible: false });
            }
        }
        if (nextProps.rateState.dataSyncLanguage && !isEqual(nextProps.rateState.dataSyncLanguage, this.props.rateState.dataSyncLanguage) && !nextProps.rateState.isSyncLanguageSuccess) {
            if (nextProps.rateState.dataSyncLanguage && Object.keys(nextProps.rateState.dataSyncLanguage).length > 0) {
                // this.setState({isShowError: true})
                this.showReplaceLanguageSync(nextProps.rateState.dataSyncLanguage)
            }
        }
    }

    showConfirmSync = () => {
        this.setState({ isVisibleSyncModal: true })
    }

    handleOkSyncModal = (rateCodes) => {
        const { t, match, rateState } = this.props;
        this.setState({ isVisibleSyncModal: false })
        if (this.isCheckSync) {
            this.isCheckSync = false;
            this.props.syncRates(match.params.hotel_id, rateCodes, true);
        }
        // confirm({
        //     title: t('action.sync'),
        //     content:  <span>{t('item.rate.confirmSync')}</span>,
        //     onOk: () => {
        //         if(this.isCheckSync){
        //             this.isCheckSync = false;
        //             this.props.syncRates(match.params.hotel_id, rateCodes, true);
        //         }
        //         // debounce(() => {this.props.syncRates(match.params.hotel_id, true)}, 500)();
        //     },
        //     onCancel() {},
        //     okText: t(`action.sync`),
        //     cancelText: t(`action.cancel`)
        // });
    };

    showReplaceLanguageSync = (data) => {
        const { t, match } = this.props;
        const prefix = t('item.rate.syncRateLanguage.confirmSyncLanguagePrefix');
        const suffix = t('item.rate.syncRateLanguage.confirmSyncLanguageSuffix');
        const requesttLang = t(`translate.languages.${data.languageCodeNew.split('-')[0]}`);
        const currentLang = t(`translate.languages.${data.languageCodeOld.split('-')[0]}`);
        this.setState({ replaceLanguage: 'vi-VN' });

        confirm({
            title: t('action.sync'),
            content: <span>
                <span>
                    {`${prefix} ${requesttLang}`}
                </span> <br />
                <span>
                    {`${suffix} ${currentLang}`}
                </span>
                <PopUpConfirm {...this.props} onSelected={this.onChangeReplaceLanguage} />
            </span>,
            onOk: () => {
                if (this.state.replaceLanguage) {
                    this.onSyncRateLanguage({
                        res: {
                            hotelId: data.hotelId,
                            ratePlanId: data.ratePlanId,
                            languageCodeNew: this.state.replaceLanguage,
                            languageCodeOld: data.languageCodeOld
                        }
                    });
                }
            },
            okText: t(`action.confirm`)
        })
    }

    onChangeReplaceLanguage = (replaceLanguage) => {
        this.setState({ replaceLanguage: replaceLanguage })
    }

    handleOK = () => {
        this.setState({ visible: false });
    }

    changStatusSynRateNew = () => {
        const { t, rateState } = this.props;
        const { dataSync } = rateState;
        const { isVisible } = this.state;
        return (
            <Modal className="surcharge-detail"
                destroyOnClose={true}
                visible={isVisible}
                width={800}
                title={t(`item.rate.newRate.title`)}
                onOk={this.onSubmit}
                okText={t(`action.update`)}
                onCancel={this.onCancel}
                cancelText={t(`action.cancel`)}
            >
                <List
                    size="small"
                    dataSource={(dataSync || [])}
                    split={isVisible}
                    renderItem={(item, idx) =>
                        <List.Item className="row">
                            <Wrapper className="col-md-4">
                                <Checkbox value={idx} onChange={(e) => this.onChangeCheckBox(e.target.checked, idx)}>
                                    {item.name}
                                </Checkbox>
                            </Wrapper>
                            <Wrapper className="col-md-3">
                                {item.dc &&
                                    item.dc.map(typeId => <HMS.StatusComponent color={HOTEL.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red'}
                                        label={HOTEL.TYPE_RATE[CONFIG.ENV][typeId]} />)
                                }
                            </Wrapper>
                            <Wrapper className="col-md-5">
                                {item.description}
                                {/* {item.promotionalDescription || item.termsDescription} */}
                            </Wrapper>
                        </List.Item>}
                />
            </Modal>
        )
    }

    render() {
        const { t, match, hotelState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, dataList, isFetchSync, isFetchActive, isFetchExtend } = this.props.rateState;
        const pagination = { totalCount, totalPage, pageIndex, pageSize };
        const { isSort, rates, isVisibleSyncModal } = this.state;

        return (
            <Fragment>
                {this.changStatusSynRateNew()}
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'rate'}
                        titleHeader={`${t('navigation.rates')} - ${hotelState?.detail?.hotel?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Wrapper className="rates-header-actions">
                                <RenderHotelisActive
                                    onChangedHotel={this.onChangeHotel}
                                    defaultHotelId={match.params.hotel_id}
                                    isBeachVilla={hotelState?.detail?.hotel.isBeachVilla}
                                />
                                {
                                    hotelState?.detail?.hotel.isBeachVilla ?
                                        <Link
                                            to={Func.getPathWithParams(PATHS.RATE.CREATE.path, {
                                                hotel_id: match.params.hotel_id,
                                            })}
                                            className='btn btn-primary'
                                            style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                                        >
                                            + {t(`action.create`)}
                                        </Link> :
                                        <Fragment>
                                            {
                                                !isSort ?
                                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                                        <Button
                                                            className='btn btn-primary'
                                                            style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                                                            onClick={this.toggleSort}>
                                                            {t(`action.sort`)}
                                                        </Button>
                                                    </Ripple> :
                                                    <Fragment>
                                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                                            <Button
                                                                className='btn btn-default'
                                                                style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                                                                onClick={this.cancelSort}>
                                                                {t(`action.cancel`)}
                                                            </Button>
                                                        </Ripple>
                                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                                            <Button
                                                                className='btn btn-primary'
                                                                style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                                                                disabled={isEqual(dataList, rates)}
                                                                onClick={this.applySortList}>
                                                                {t(`action.save`)}
                                                            </Button>
                                                        </Ripple>
                                                    </Fragment>
                                            }
                                            {
                                                permisionActions && permisionActions.allowSync &&
                                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                                    <Button
                                                        icon="sync"
                                                        loading={isFetchSync}
                                                        onClick={this.showConfirmSync}
                                                        className='btn btn-primary'
                                                        style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                        {t(`action.sync`)}
                                                    </Button>
                                                </Ripple>
                                            }
                                        </Fragment>
                                }
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button
                                        icon="upload"
                                        onClick={this.showImportModal}
                                        className='btn btn-primary'
                                        style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                                        Tải lên Mô tả rate code
                                    </Button>
                                </Ripple>
                            </Wrapper>
                        }
                    />
                    <Alert message={t('notification.infoSort')} type="info" showIcon />
                    <RateList
                        getListRates={() => this.props.getListRates(this.state.filters)}
                        loading={isFetching}
                        loadingStatus={isFetchActive}
                        loadingExtendRate={isFetchExtend}
                        hotelId={match.params.hotel_id}
                        permisions={permisionActions}
                        dataList={rates}
                        filters={this.state.filters}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        isSort={isSort}
                        moveRow={this.moveRow}
                        onUpdateRateActive={this.onUpdateRateActive}
                        onSyncRateLanguage={this.onSyncRateLanguage}
                        onUpdateRateExtend={this.onUpdateRateExtend}
                        isBeachVilla={hotelState?.detail?.hotel.isBeachVilla}
                        hotelName={hotelState?.detail?.hotel?.name}
                    />
                </HMS.PageListComponent>

                {isVisibleSyncModal &&
                    <SyncModal
                        visible={isVisibleSyncModal}
                        setVisible={(visible) => { this.setState({ isVisibleSyncModal: visible }) }}
                        handleOkSyncModal={this.handleOkSyncModal}
                        title={hotelState?.detail?.hotel?.name}
                    />}

                <ImportModal
                    visible={this.state.isVisibleImportModal}
                    onClose={() => this.setState({ isVisibleImportModal: false })}
                    onUpload={this.handleImportUpload}
                />
            </Fragment>
        );
    }

    showImportModal = () => {
        this.setState({ isVisibleImportModal: true });
    }

    handleImportUpload = async ({ file }) => {
        const hotelId = this.props.match.params.hotel_id;
        try {
            await importRateDescription(hotelId, file);
            message.success('Tải lên mô tả rate code thành công');
        } catch (err) {
            const blob = err && err.data;
            const isErrorFile = err && err.status === 400 && blob instanceof Blob;
            if (isErrorFile) {
                const headers = err.headers || {};
                const filename =
                    parseFilenameFromContentDisposition(headers['content-disposition']) ||
                    'rate-description-import-errors.xlsx';
                const fileType =
                    headers['content-type'] ||
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                Func.downloadFile(blob, filename, { type: fileType });
                message.error('Tải lên thất bại. File lỗi đã được tải về để bạn kiểm tra.');
            } else {
                message.error('Tải lên thất bại. Vui lòng thử lại.');
            }
            this.setState({ isVisibleImportModal: false })
            throw err;
        }
    }

    onChangeHotel = (hotelId) => {
        if (hotelId) {
          const newFilters = {
            ...this.state.filters,
            hotelId,
            isActive: true,
            pageIndex: 1,
          };
          this.setState({ filters: newFilters });
          this.props.getListRates(newFilters);
          this.props.getHotelDetail && this.props.getHotelDetail(hotelId);
          this.props.history.replace(generatePath(PATHS.RATE.LIST.path, {hotel_id: hotelId}));
        }
    };

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        delete newFilters.dayOfWeek;
        const isActiveFilter = Array.isArray(newFilters.isActive) ? newFilters.isActive[0] : newFilters.isActive;
        if (isActiveFilter === undefined || isActiveFilter === null || isActiveFilter === '' || isActiveFilter === '__all__') {
            delete newFilters.isActive;
        } else {
            newFilters.isActive = isActiveFilter === true || isActiveFilter === 'true';
        }
        newFilters.hotelId = this.props.match.params.hotel_id;
        this.setState({
            filters: newFilters
        });
        this.props.getListRates(newFilters);
    };

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && this.state.preHotelId) {
            const path = Func.getPathWithParams(PATHS.HOTEL.DETAIL.path, { id: match.params.hotel_id })
            this.props.history.push(path);
        }
    }

    onChangeLanguage = (language) => {
        this.props.getListRates(this.state.filters)
    }

    onChangeCheckBox = (check, index) => {
        const { ratesActive } = this.state;
        if (check) {
            this.setState({ ratesActive: [...ratesActive, index] })
        } else {
            ratesActive.splice(index, 1)
            this.setState({ ratesActive });
        }
    }

    onCancel = () => {
        this.setState({ isVisible: false });
    }

    onSubmit = () => {
        const { ratesActive, filters } = this.state;
        const { t, rateState } = this.props;
        const { dataSync } = rateState;
        if (ratesActive && ratesActive.length > 0) {
            const res = ratesActive.map(item => {
                return {
                    id: dataSync[item].id,
                    usageStatus: true
                }
            })
            this.props.usageStatus({ ratePlans: res }, filters);
            this.setState({ isVisible: false });
        }
    }

    toggleSort = () => {
        if (this.state.rates.length > 0) {
            this.setState({ isSort: true })
            message.info(this.props.t('notification.acceptSort'));
        }
    }

    cancelSort = () => {
        this.setState({ rates: this.props.rateState.dataList, isSort: false })
    }

    moveRow = (hoverIndex, dragFields, headSelect) => {
        // const { rates } = this.state;
        // const dragRow = rates[dragIndex];
        let lengthRows = dragFields.length;
        this.setState(
            update(this.state, {
                rates: {
                    $splice: [[headSelect, lengthRows],
                    [
                        (lengthRows === 1 || hoverIndex < headSelect) ? hoverIndex : (hoverIndex - lengthRows)
                        , 0, ...dragFields
                    ]],
                },
            }),
        );
    };

    applySortList = () => {
        const { rates } = this.state;
        const languageCode = getContentLanguage()
        const sortedRates = rates.map((item, index) => ({ ratePlanId: item.id, languageCode, order: index }))
        this.props.sortRates(sortedRates, this.state.filters);
        this.setState({ isSort: false })
    }

    onUpdateRateActive = (obj) => {
        const { filters } = this.state;
        this.props.updateRateActive({
            ...obj,
            filters: filters
        });
    }

    onUpdateRateExtend = (obj) => {
        const { filters } = this.state;
        this.props.updateRateExtend({
            ...obj,
            filters: filters
        })
    }

    onSyncRateLanguage = (obj) => {
        const { filters } = this.state;
        this.props.syncRateLanguage({
            ...obj,
            filters: filters
        })
    }
}
